import { TopLogoView } from "@quest/murka-games-behavior-leopard/dist/Game/TopLogo/TopLogoView";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist/";
import { dispatcher, ingenuity } from "@quest/base-core";
export class TopLogoViewGame extends TopLogoView {
    // override TopLogoView & BaseViewBehavior
    public resize() {
        if (!ingenuity.deviceEnv.isDesktop) {
            if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
                this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
                this.updateOrientation();
            }
        }
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstantsBehavior.baseGameState || ingenuity.configData.showBaseGameScreen) {
            if (ingenuity.deviceEnv.getOrientation() === "portrait") {
                this.topSpace();
                this.visible && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
            }
            else {
                dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_LANDSCAPE_LOGO);
                dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
            }
        }
    } 
    //Function overided to remove button shape and update pivot value
    public topSpace(): void {
        if (this.currentStateView) {
            const logoHeightBg = this.getShapeById("logoHeightBg");
            if (logoHeightBg) {
                const wrapperTopBarHeight = document.getElementById("topbar") ? (document.getElementById("topbar").offsetHeight ? document.getElementById("topbar").offsetHeight : SlotConstantsBehavior.WrapperBottomBarHeightMobilePortrait) : 0;
                const reelBgHeight = SlotConstantsBehavior.REEL_MAXSCALE_HEIGHT;
                const topSpace = ((window.innerHeight / 2 + SlotConstantsBehavior.ADD_IN_Y) - (reelBgHeight / 2) * this.currentStateView.scale.x) - (wrapperTopBarHeight);
                const availableScaling = Math.min(topSpace / logoHeightBg.height, window.innerWidth / logoHeightBg.width);
                dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_LANDSCAPE_LOGO);
                this.showView();
                this.scale.set(availableScaling);
                this.pivot.set(logoHeightBg.width / 2, logoHeightBg.height / 2);
                this.x = window.innerWidth / 2;
                this.y = wrapperTopBarHeight + topSpace / 2;
            }
            // const stateViewIndex = ingenuity.currentGame.stage.getChildIndex(this.currentStateView);
            !ingenuity.configData.bigWinRunning && ingenuity.currentGame.stage.addChild(this);
        }
    }

    showView(): void {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstantsBehavior.baseGameState || ingenuity.configData.showBaseGameScreen) {
            this.visible = true;
        }
        else {
            this.hideView();
        }
    }
}